export const getDstName = (teamCity: string, teamName: string, toBeShortended: boolean = false) => {
  const defTeamName = toBeShortended ? `${teamName} DST` : `${teamCity} ${teamName} DST`
  return defTeamName
}
